import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Memoji.png";
import Tilt from "react-parallax-tilt";
import styled from "styled-components";

const StyledSection = styled.section`
  color: var(--text-primary);
  position: relative;
  padding: 0 0 50px;
  margin-top: -200px;
  overflow: hidden;
  z-index: 0;

  .purple {
    color: var(--imp-text-color);
  }

  .home-about-description {
    font-family: "Inter", sans-serif;
    padding: 20px 0;
  }

  h1 {
    font-family: "Inter", sans-serif;
    color: var(--imp-text-color);
    font-size: 2.2em;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }

  .home-about-body {
    font-size: 1.1rem;
    margin-top: 20px;
    line-height: 1.7;
    color: var(--text-secondary);
  }

  i {
    font-family: "Inter", sans-serif;
    color: var(--imp-text-color);
    font-style: normal;
    font-weight: 500;
  }
  
  .myAvtar {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .myAvtar img {
    max-width: 250px;
    border-radius: 50%;
    transition: all 0.3s ease;
  }
  
  @media (max-width: 767px) {
    padding: 0 0 30px;
    margin-top: -130px;
    
    h1 {
      font-size: 1.8em;
      margin-bottom: 1rem;
      text-align: center;
    }
    
    .home-about-description {
      padding: 10px 0;
      text-align: center;
    }
    
    .home-about-body {
      font-size: 1rem;
      text-align: left;
    }
    
    .myAvtar {
      padding: 20px 0;
      margin-top: 20px;
    }
    
    .myAvtar img {
      max-width: 200px;
    }
  }
`;

function Home2() {
  return (
    <StyledSection>
      <Container fluid className="home-about-section" id="about">
        <Container>
          <Row className="align-items-center">
            <Col md={7} className="home-about-description">
              <h1>
                Laissez moi me présenter
              </h1>
              <p className="home-about-body">
                Passionné par la programmation, j'ai développé de solides compétences techniques à travers mes projets et mes études 🤷‍♂️
                <br />
                <br />
                Je maîtrise plusieurs langages de programmation, notamment{" "}
                <i>
                  C++, Javascript et Python
                </i>
                <br />
                <br />
                Mes domaines d'expertise incluent{" "}
                <i>
                  la cybersécurité avec Root-Me et TryHackMe ainsi que
                  la participation à des bug bounty
                </i>
                <br />
                <br />
                Dans mon parcours professionnel, je me concentre sur le développement web avec Node.js et{" "}
                <i>
                  des bibliothèques et frameworks modernes
                </i>
                &nbsp; tels que{" "}
                <i>
                  React.js et Qt pour le C++
                </i>
              </p>
            </Col>
            <Col md={5} className="myAvtar">
              <Tilt tiltMaxAngleX={15} tiltMaxAngleY={15} scale={1.05} transitionSpeed={2000}>
                <img src={myImg} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>
    </StyledSection>
  );
}

export default Home2;